import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  changeState,
  loadUserFromSession,
  atualizaLocalizacao,
} from '../actions';

import Header from './Header';
import './Main.css';

import Footer from './Footer';

import ModalBuscaCameras from './ModalBuscaCameras';

class Main extends Component {
  constructor(props) {
    super(props);

    props.changeState(props.location.pathname);
    props.history.listen((location, action) => {
      props.changeState(location.pathname);
    });
  }

  componentWillMount() {
    return !this.props.userIsAuthenticated && this.props.loadUserFromSession();
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.userIsLoading && !nextProps.userIsAuthenticated) {
      this.props.history.push('/login');
    }
    else if (this.props.location.pathname === '/') {
      this.props.history.push('/marcadores');
    }
  }

  render() {
    const {
      children,
      isModalBuscaCamerasOpened,
      userIsAuthenticated,
    } = this.props;

    return (
      <div className="mdl-layout mdl-js-layout mdl-layout--fixed-header">
        <Header isReady={ userIsAuthenticated } />
        <ToastContainer />
        <main className="mdl-layout__content">
          { children }
        </main>
        { isModalBuscaCamerasOpened && <ModalBuscaCameras /> }
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userIsLoading: state.userIsLoading,
    userIsAuthenticated: state.userIsAuthenticated,
    isModalBuscaCamerasOpened: state.isModalBuscaCamerasOpened,
  }
}
const mapDispatchToProps = {
  atualizaLocalizacao,
  changeState,
  loadUserFromSession,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));



// WEBPACK FOOTER //
// ./src/components/Main.js